import * as React from 'react'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import TableEmpty from '@/modules/drivers/shared/tableItems/TableEmpty'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getImiValidationColumns } from './columns'
import ImiDriverValidationRow, {
  ImiDriverValidationInfo,
} from './ImiDriverValidationRow'

type ImiDriverValidationTableProps = {
  drivers: ImiDriverValidationInfo[]
  submitted: boolean
  dateRange: string
  countriesText: string
  operationTypesText: string
  transportTypesText: string
  vehiclesText: string
}


const ImiDriverValidationTable: React.FC<ImiDriverValidationTableProps> = ({
  drivers,
  submitted,
  dateRange,
  countriesText,
  operationTypesText,
  transportTypesText,
  vehiclesText,
}) => {
  const { t } = useLocalize()
  const columns = React.useMemo(() => getImiValidationColumns(t), [t])

  return (
    <section className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
      {drivers.length > 0 ? (
        <div className="tw-h-full tw-overflow-y-auto tw-bg-base-100">
          <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2">
            <TableHeader
              opacity
              rounded={false}
              disabledCheckboxToggle
              columns={columns}
              sortConfig={null}
              sticky
              onHeaderClick={undefined}
            />
            <tbody>
              {drivers.map((info) => (
                <ImiDriverValidationRow
                  key={info.id}
                  info={info}
                  submitted={submitted}
                  dateRange={dateRange}
                  countriesText={countriesText}
                  operationTypesText={operationTypesText}
                  transportTypesText={transportTypesText}
                  vehiclesText={vehiclesText}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2">
            <TableHeader
              opacity
              disabledCheckboxToggle
              columns={columns}
              sortConfig={null}
            />
          </table>
          <TableEmpty title={t('driverModule.no-drivers-selected')} />
        </>
      )}
    </section>
  )
}

export default ImiDriverValidationTable
